import { render, staticRenderFns } from "./creatVideoChannel.vue?vue&type=template&id=db42d2d8&scoped=true"
import script from "./creatVideoChannel.vue?vue&type=script&lang=js"
export * from "./creatVideoChannel.vue?vue&type=script&lang=js"
import style0 from "./creatVideoChannel.vue?vue&type=style&index=0&id=db42d2d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db42d2d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db42d2d8')) {
      api.createRecord('db42d2d8', component.options)
    } else {
      api.reload('db42d2d8', component.options)
    }
    module.hot.accept("./creatVideoChannel.vue?vue&type=template&id=db42d2d8&scoped=true", function () {
      api.rerender('db42d2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/videoChannel/draftList/creatVideoChannel.vue"
export default component.exports